export default "__VITE_ASSET__eb6cca75__"